import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import Logo from '@/components/Logo';

export default function ThankYou() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Force Spanish for the thank-you page as per spec.
    if (i18n.language !== 'ar') i18n.changeLanguage('ar');
    document.documentElement.lang = 'es-AR';
    document.title = '¡Gracias! — Zantravina';
  }, [i18n]);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--paper)', display: 'flex', flexDirection: 'column' }}>
      <div className="container-zt" style={{ paddingTop: 32 }}>
        <Link to="/" aria-label="Zantravina" data-testid="thankyou-logo"><Logo /></Link>
      </div>
      <div style={{ flex: 1, display: 'grid', placeItems: 'center', padding: 40 }}>
        <div style={{ maxWidth: 640, textAlign: 'center' }}>
          <div className="eyebrow" style={{ marginBottom: 20 }}>Zantravina</div>
          <h1 className="font-display" style={{ fontSize: 'clamp(40px, 6vw, 72px)', lineHeight: 1, letterSpacing: '-0.02em' }}>¡Gracias por escribirnos!</h1>
          <p style={{ marginTop: 24, fontSize: 18, lineHeight: 1.6, color: 'var(--ink-2)' }}>
            Recibimos tu mensaje correctamente. El equipo de Zantravina va a leerlo y responderte por correo electrónico durante los próximos días hábiles.
          </p>
          <p style={{ marginTop: 12, fontSize: 15, color: 'var(--stone)' }}>
            Mientras tanto, si querés, podés seguir leyendo sobre cómo funciona el crowdlending inmobiliario en Argentina.
          </p>
          <div style={{ marginTop: 32 }}>
            <Link to="/" className="btn btn-primary" data-testid="thankyou-back">
              <ArrowLeft size={16} /> Volver al inicio
            </Link>
          </div>
        </div>
      </div>
      <div className="container-zt" style={{ paddingBottom: 32, fontSize: 12, color: 'var(--stone)', textAlign: 'center' }}>
        © {new Date().getFullYear()} Zantravina S.A.S. Todos los derechos reservados.
      </div>
    </div>
  );
}
